export function getApiBase() {
	// Keep browser API calls on the document's origin, including apex/www and
	// Heroku hosts, so the Gateway connect-src 'self' policy permits them.
	try {
		if (['http:', 'https:'].includes(window.location.protocol)) {
			return window.location.origin;
		}
	} catch {
		// ignore
	}
	// Non-browser / non-HTTP callers retain the production fallback.
	return 'https://www.tutory.app';
}

